import React from "react";
import { Interweave } from "interweave";
const HTMLParser = ({ children }) => {
  return <Interweave content={children}></Interweave>;
};

export default HTMLParser;
